module.exports = __webpack_public_path__ + "static/media/oulis.de29b1cf.png";